<template>
    <div class="float-left mr-1">
        <b-button variant="primary" @click="abrirModal()">
            <span> <i class="fa fa-plus mr-2"></i> Inserir Documento </span>
        </b-button>
        <b-modal
            id="modalInserirDocumento"
            size="lg"
            v-model="mostrarModal"
            no-close-on-backdrop>
            <div slot="modal-title">
                Documento -
                <b-badge variant="warning">{{ operacao }}</b-badge>
            </div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Nome do arquivo</label>
                        <b-form-textarea
                            :rows="4"
                            v-model="descricaoArquivo"
                        ></b-form-textarea>
                        <b-form-invalid-feedback>
                            O nome do arquivo é obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label>Arquivo</label>
                        <b-form-file
                            v-model="arquivo"
                            :state="Boolean(arquivo)"
                            placeholder="Selecione um documento em PDF ou Excel..."
                            ref="arquivoInput"
                        ></b-form-file>
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button variant="secondary" @click.stop="fecharModal()">
                    Cancelar
                </b-button>
                <b-button
                    variant="primary"
                    class="ml-1"
                    @click.stop="salvarDocumento()"
                    :disabled="this.$v.$invalid">
                    Salvar
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
//import EventosServicos from './EventosServicos'
import { required } from 'vuelidate/lib/validators'
import ConveniosServicos from '../../../fornecedor/ConvenioServicos'

export default {
    props: {
        licitacao: {
            type: Object,
            default: () => ({})
        }
    },
    validations: {
        descricaoArquivo: { required },
        arquivo: { required }
    },

    data() {
        return {
            mostrarModal: false,
            operacao: 'NOVO',
            erros: [],
            vcNomeArquivo: null,
            arquivo: null,
            descricaoArquivo: null,
            }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
           // this.obterTiposDocumentos()
        },

        fecharModal() {
            this.mostrarModal = false
        },
        
        salvarDocumento() {
            this.$store.dispatch('addRequest')
            let documentoDto = {
                vcNomeArquivo: this.arquivo.name,
                arquivo: this.arquivo,
                idLicitacao: this.licitacao.idLicitacao,
                descricaoArquivo:this.descricaoArquivo
            }
            ConveniosServicos.inserirDocumentosLicitacao(documentoDto).then((response) => {
                if (response) {
                    if (response.success) {
                        this.documentos = response.data
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        }
    }
}
</script>
